import { createContext, useContext } from "react";

import type { YearPickerContextValue } from "./YearPicker.types";
import { decadeOf, thisYear } from "./yearMath";

export function makeYearPickerContext({
  size = "md",
  layout = "default",
  disabled = false,
  arrow = true,
  viewDecade = decadeOf(thisYear()),
  selected = null,
  min = null,
  max = null,
  pointerOffsetRef = { current: 0 },
  selectYear = () => {},
  goToDecade = () => {},
  goToView = () => {},
}: Partial<YearPickerContextValue>): Required<YearPickerContextValue> {
  return {
    size,
    layout,
    disabled,
    arrow,
    viewDecade,
    selected,
    min,
    max,
    pointerOffsetRef,
    selectYear,
    goToDecade,
    goToView,
  };
}

export const YearPickerContext = createContext<
  Required<YearPickerContextValue>
>(makeYearPickerContext({}));

export function useYearPickerContext() {
  return useContext(YearPickerContext);
}
